

















































import Vue from 'vue'
// import Vue from './mixin'
import { Stack, CreateStack } from '@/api/cems'

export default Vue.extend({
  data() {
    return {
      stack: {} as Stack,
    }
  },

  methods: {
    async createStack() {
      await CreateStack(this.stack)
      this.$router.go(-1)
    },
  },
  created() {
    //
  },
})
